import { render } from "./AdComponent.vue?vue&type=template&id=3a20fcea"
import script from "./AdComponent.vue?vue&type=script&lang=js"
export * from "./AdComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__